import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
    background-color: lightsalmon;
    height: 100%; 
`;

const Home = () => (
    <Div color>Home page</Div>
);

export default Home;


// WEBPACK FOOTER //
// ./src/components/Page/Home/default.jsx